import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { mobile, tablet, desktopUp } from '~styles/global'
import { NextButton, Heading } from '~components/ChecklistSlide'

const ChecklistQuestion = ({ className, slide, next, handleAnswer, checklist, slides }) => {
	const currentSection = slide.sections?.find(section => section.title === slide.section)
	const currentSectionIndex = slide.sections?.findIndex(section => section.title === slide.section)
	const options = slide?.question?.answers?.length > 0 ? slide?.question?.answers : ['never', 'sometimes', 'often', 'constantly']
	const [value, setValue] = useState()
	const allQuestions = slide.sections.map(section => section.questions)?.flat()

	const trackingData = {
		event: 'custom.form.page.complete',
		action: 'page complete',
		type: slide.type,
		text: 'Continue',
		section: {
			name: currentSection.title,
			number: currentSectionIndex + 2,
			total: 5
		},
		question:{
			totalsection: currentSection?.questions?.length,
			total: slide.sections.map(section => section.questions)?.flat()?.length,
			number: currentSection?.questions?.findIndex(q => q.text === slide.question.text) + 1,
			numberTotal: allQuestions.findIndex(q => q.text === slide.question.text) + 1,
			name: slide.question.text,
			answer: value,
		},
		page: {
			number: slides?.findIndex(s => s.question === slide.question) + 1,
			numberTotal: slides?.length,
		},
		checklist: checklist?.slug?.current,
	}

	useEffect(() => {
		if(slide.userData){
			const answerInData = slide.userData?.answers?.find(a => a.question === slide.question)
			if(answerInData){
				setValue(answerInData.value)
			}
		}
	}, [slide.userData?.answers])

	const handleInternalAnswer = option => {
		setValue(option)
		console.log(option)
		handleAnswer({value: option, question: slide.question, section: slide.section})
		window.setTimeout(() => {
			next(trackingData)
		}, 400)
	}

	return (
		<Wrap className={className}>
			<Heading>{slide.index + 1} of {currentSection.questions?.length}</Heading>
			<Text>
				<h6>{slide.question.text}</h6>
				<p>{slide.question.subText}</p>
			</Text>
			<Answers nonStandard={slide?.question?.answers?.length > 0}>
				{options?.map(option => 
					<Answer 
						key={option} 
						onClick={() => handleInternalAnswer(option)} 
						active={value === option}
						nonStandard={slide?.question?.answers?.length > 0}
						>
						{option}
					</Answer>
				)}
				{slide?.question?.answers?.length > 0 &&
					<Answer inverse nonStandard onClick={() => handleInternalAnswer('undefined')}>Skip</Answer>
				}
			</Answers>
			{/* <NextButton onClick={() => } bgColor='bteal60' active={value} checklist>Continue</NextButton> */}
		</Wrap>
	)
}

const Wrap = styled.div`
	text-align: center;
	/* padding: var(--m); */
`

const Text = styled.div`
	margin: var(--xl) auto var(--xl);
	max-width: 500px;
	min-height: 160px;
	h6{
		margin-bottom: 0.6em;
	}
	${mobile}{
		margin: var(--s) auto var(--m);
	}
`

const Answers = styled.div`
	display: flex;
	margin-bottom: var(--xl);
	gap: 5px;
	justify-content: center;
	flex-wrap: ${props => props?.nonStandard ? 'wrap': 'none'};
	${mobile}{
		display: block;
		margin-bottom: 0;
	}
`

const Answer = styled.button`
	border-right: none;
	width: ${props => props?.nonStandard ? 'none': '100%'};
	display: inline-block;
	padding: var(--xs);
	background: ${props => props.active ? 'var(--dteal)' : props.inverse ? 'var(--white)' : 'var(--bteal60)'};
	border: 3px solid ${props => props.active ? 'var(--dteal)' : props.inverse ? 'var(--dteal)' : 'var(--bteal60)'};
	color: ${props => props.active ? 'var(--white)' : 'inherit'};
	text-transform: capitalize;
	font-weight: 700;
	border-radius: 4px;
	min-width: ${props => props?.nonStandard ? '130px': 'none'};
	box-sizing: border-box;
	${desktopUp}{
		&:hover{
			background: ${props => props.active ? 'var(--dteal)' : props.inverse ? 'var(--white)' : 'var(--bteal60)'};
			border: 3px solid var(--Panda-Dark-Teal-100, #11383A);
		}
	}
	${mobile}{
		/* border: 3px solid var(--dteal); */
		margin-bottom: 10px;
		/* border-bottom: none; */
		width: 100%;
		&:last-child{
			/* border-bottom: 3px solid var(--dteal); */
		}
	}
`

ChecklistQuestion.propTypes = {
	className: PropTypes.string,
	slide: PropTypes.object,
	checklist: PropTypes.object,
	next: PropTypes.func,
	handleAnswer: PropTypes.func,
	slides: PropTypes.array,
}

export default ChecklistQuestion